import { AuthResponse } from "../../services/auth/auth.model";

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AuthAction {
  export class Login {
    static readonly type = '[Login] User login';
    constructor(public authToken: string) {}
  }

  export class Logout {
    static readonly type = '[Logout] User logout';
    constructor(public isAuth: boolean = false) {}
  }

  export class AuthResAction {
    static readonly type = '[authRes] state';
    constructor(public authResponse: AuthResponse) {
     
    }
  }
}
